<template lang="pug">
GenericCard.allsales-print-panel(size='40')
  .d-flex.flex-column.px-4.py-4
    .text-large
      | พิมพ์สรุปรายการขาย
    CustomDatePickerSingle.mt-3.mx-auto(
      v-model='selectedDate'
    )
    CustomInputSelectJson.mt-2.mx-auto(
      style='width: 180px'
      v-model='filterStatus'
      :options=`ORDER_STATUSES`
    )

    .d-flex.justify-content-center.mt-3
      button.btn.btn-upa-secondary.px-3(
        @click='downloadPDF'
      )
        i.fa.fa-print.mr-1
        | พิมพ์

      //- F said doesn't exists
      //- button.btn.btn-upa-secondary.ml-2.px-3(
      //-   @click='downloadXLS'
      //- )
      //-   i.fa.fa-download.mr-1
      //-   | ดาวโหลดเป็น .xls

  //- hr.m-0.w-100
  //- .d-flex.flex-column
  //-   template(v-if='error')
  //-     .text-center.text-medium.red.p-3
  //-       | {{ error }}
  //-   template(v-else-if='success')
  //-     //- .alert.alert-success
  //-     .text-center.text-medium.p-3
  //-       img.mr-2(src='@/assets/icons/success.svg' width='20px')
  //-       | ดาวโหลดไฟล์สำเร็จ
</template>

<script>
const ORDER_STATUSES = [
  { value: '', text: 'ทุกรายการ' },
  { value: 'pending', text: 'รายการรออนุมัติ' },
  { value: 'submitted', text: 'รายการ UNIX' },
  { value: 'submitted', text: 'รายการที่ถูกยกเลิก' },
];

export default {
  data() {
    return {
      ORDER_STATUSES,
      filterStatus: '',

      selectedDate: this.$moment().startOf('day').toDate(),

      // error: null,
      // success: false,
    };
  },
  computed: {
    urlForPDF() {
      return this.$api.admin.report.salesReportURL(
        this.selectedDate,
        this.filterStatus,
      );
    },
    urlForXLS() {
      return this.$api.admin.report.salesExcelURL(
        this.selectedDate,
        this.filterStatus,
      );
    },
  },
  methods: {
    async downloadPDF() {
      window.open(this.urlForPDF);
    },
    async downloadXLS() {
      window.open(this.urlForXLS);
    },
  },
};
</script>

<style lang="scss">
// .line-api-panel {}
</style>
